import { CompanyProfile } from 'models';

const ShowtimeHelpers = {
    slackDetails: ({
        company,
        replusNotified,
    }: {
        company: Pick<CompanyProfile, 'name' | 'internal'>;
        replusNotified?: boolean;
    }) => {
        if (!company.internal) {
            return [`🏢 Profile: *${company.name}* (claimed)`];
        }

        return [
            `🏢 Profile: *${company.name}* (not claimed)`,
            ...(replusNotified ? ['📧 RE+ has been notified of this scan'] : []),
        ];
    },

    urls: {
        showtime: () => '/resourcepro/showtime',
    },

    swr: {
        qrScans: (eventId?: string) => `/api/qrScans?eventId=${eventId}`,
        qrScansByCompany: (companyId: string) => `/api/qrScansByCompany/${companyId}`,
    },

    localStorageKey: {
        scannedQr: 'scannedQr',
    },
};

export { ShowtimeHelpers };
